import { assertValued } from './util';
export class ContextService {
    constructor(uiConfigRepository) {
        this.config = uiConfigRepository.getUiConfig();
        this.resolvedContextId = this.config.contextId;
    }
    getContextId() {
        return this.config.contextId;
    }
    getTheme() {
        return this.config.theme;
    }
    getResolvedContextId() {
        return assertValued(this.resolvedContextId);
    }
    async getContextName(id) {
        switch (id) {
            case 'a24f77d8-3dca-4136-87ec-f31dab970fba': return 'root';
            case '23e7bfac-15f7-4dde-acbd-b2f8bd3af50d': return 'pld';
            case 'c228fc60-8fa8-46c4-b0f6-ab44bc4a1865': return 'strada';
        }
        throw `Unknown context ${id}`;
    }
}
